import styled from 'styled-components';
import { ReactComponent as LeadDeltaSvg } from '../../../assets/img/leaddelta-icon.svg';
import chromeIconUrl from '../../../assets/img/chrome-icon.svg';

export const OnboardingConnectionIconRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 32px;
    width: 100%;
`;

export const LeadDeltaOnboardingIcon = styled(LeadDeltaSvg)`
    width: 61px;
    height: 60px;
    flex-shrink: 0;
`;

export const ChromeOnboardingIcon = styled.img.attrs({
    src: chromeIconUrl,
    alt: '',
})`
    width: 60px;
    height: 60px;
    flex-shrink: 0;
`;

export const OnboardingLinkIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <path
            d="M10 13C10.4295 13.5746 10.9774 14.0491 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9904C14.3618 15.0397 15.0796 14.9326 15.7513 14.6767C16.4231 14.4209 17.0331 14.0226 17.54 13.51L20.54 10.51C21.4508 9.51766 21.9548 8.19906 21.9434 6.83412C21.932 5.46919 21.4061 4.15912 20.4791 3.18213C19.5521 2.20514 18.2967 1.63977 16.9679 1.61554C15.6391 1.59131 14.364 2.11024 13.4 3.05L11.75 4.69"
            stroke="#8C96AD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14 11C13.5705 10.4254 13.0226 9.95087 12.3934 9.60711C11.7643 9.26334 11.0685 9.05886 10.3533 9.00959C9.63816 8.96032 8.92037 9.06742 8.24863 9.32328C7.57689 9.57913 6.96688 9.97738 6.46 10.49L3.46 13.49C2.54918 14.4823 2.04519 15.8009 2.05659 17.1659C2.06799 18.5308 2.59387 19.8409 3.52091 20.8179C4.44794 21.7949 5.70328 22.3602 7.03211 22.3845C8.36094 22.4087 9.63596 21.8898 10.6 20.95L12.24 19.31"
            stroke="#8C96AD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
